import React, { FC } from 'react'
import Slider, { CustomArrowProps } from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { WithStyles, createStyles, Theme, withStyles, Box, ButtonBase } from '@material-ui/core'
import { ChevronLeft, ChevronRight } from '@material-ui/icons'

import { IMatch } from 'protos'

import MatchCarouselItem from './MatchCarouselItem'

interface Props extends WithStyles {
  matches: IMatch[]
  selectedMatchIndex: number
  onMatchIndexChange: (matchIndex: number) => void
}

const styles = ({ spacing, palette, typography }: Theme) => createStyles({
  root: {
    paddingTop: spacing(),
    paddingBottom: spacing(3),

    '@global': {
      '*': {
        outline: 0
      },

      '.slick-prev': {
        left: 0,
      },
      '.slick-next': {
        right: 0,
      },
      '.slick-prev, .slick-next': {
        zIndex: 1,
        width: 'auto',
        height: 'auto',
        position: 'absolute',
        color: palette.accent.main,
        fontSize: typography.pxToRem(44),

        '&:before': {
          // hides the original slick icon
          display: 'none',
        },

        '&:focus': {
          outline: 0,
        }
      },
    }
  },
})

const CustomArrow: FC<CustomArrowProps> = ({ slideCount, currentSlide, ...props }) => (
  <ButtonBase {...props} />
)

const MatchCarousel: FC<Props> = ({ classes, matches, selectedMatchIndex, onMatchIndexChange }) => {
  if (matches.length === 0) {
    return null // TODO: render empty state
  }

  return (
    <div className={classes.root}>
      <Slider
        dots
        speed={500}
        infinite={false}
        afterChange={onMatchIndexChange}
        initialSlide={selectedMatchIndex}
        prevArrow={(
          <CustomArrow>
            <ChevronLeft
              fontSize="inherit"
            />
          </CustomArrow>
        )}
        nextArrow={(
          <CustomArrow>
            <ChevronRight
              fontSize="inherit"
            />
          </CustomArrow>
        )}
      >
        {matches.map(match => (
          <Box
            px={[2, 3]}
            key={match.matchId!}
          >
            <MatchCarouselItem
              match={match}
            />
          </Box>
        ))}
      </Slider>
    </div>
  )
}

export default withStyles(styles)(MatchCarousel)
